/** PURE_IMPORTS_START  PURE_IMPORTS_END */
export function isObject(x) {
    return x !== null && typeof x === 'object';
}
//# sourceMappingURL=isObject.js.map



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/internal/util/isObject.js
// module id = 175
// module chunks = 0